import Timeline from "./Timeline.js";
import TimelineVideo from "./TimelineVideo.js";
export default class Satellite {
    /*
     * Fires first
     */
    constructor() {
      // Add events
    //   _satellite.track('new_page_view'); 
      this.addEvents();  
    }
  
    /*
     * Add events
     */
    addEvents() { 
         //Save footer link interaction in local storage
        $('.js-satellite--footer-click').on('click', e => {
            e.preventDefault();  
            localStorage.setItem('_satellite--clicked-footer', $(e.currentTarget).attr('href') );
            window.location.href = $(e.currentTarget).attr('href') 
        });

         //Save carousel link interaction in local storage
         $('.slick-slide a').on('click', e => { 
            // e.preventDefault();
            
            if( !$(e.currentTarget).hasClass('js-satellite--click-download') ){
                let $wrapItem = $(e.currentTarget).closest( '.slick-slide' );

                let currentSlideIndex = $wrapItem.attr('data-slick-index');
                let slideIndex = parseInt(currentSlideIndex) +1;
    
                let slideTitle = $wrapItem.find('.js-simple-carousel__title').text();
      
                localStorage.setItem('_satellite--clicked-carousel', true );
                localStorage.setItem('_satellite--clicked-carousel-position', slideIndex );
                localStorage.setItem('_satellite--clicked-carousel-title', slideTitle );
            }
            
            // window.location.href = $(e.currentTarget).attr('href')
        }); 

        //Interaction link with email
        $('.js-satellite--email-click').on('click', e => { 
            let emailValue = $(e.currentTarget).attr('href')
            let emailAddress = emailValue.replace('mailto:', '');
            _satellite.track("email_clicked", {
                email_link: emailAddress,
            });
        }); 


 

        //Click menu levels 
        $(document).on('click', '.js-satellite--main-nav-click--top > a', e => {  
            e.preventDefault();   
            localStorage.setItem('_satellite--main-nav-click--top', $(e.currentTarget).text() );
            localStorage.setItem('_satellite--clicked-mega-menu', $(e.currentTarget).attr('href') ); 
            window.location.href = $(e.currentTarget).attr('href')
        });

        $(document).on('click', '.js-satellite--main-nav-click--second > a', e => { 
            e.preventDefault();    
            localStorage.setItem('_satellite--main-nav-click--second', $(e.currentTarget).text() );
            localStorage.setItem('_satellite--clicked-mega-menu', $(e.currentTarget).attr('href') ); 
            window.location.href = $(e.currentTarget).attr('href') 
        });

        $(document).on('click', '.js-satellite--main-nav-click--third > a', e => {  
            e.preventDefault();   
            localStorage.setItem('_satellite--main-nav-click--third', $(e.currentTarget).text() );
            localStorage.setItem('_satellite--clicked-mega-menu', $(e.currentTarget).attr('href') ); 
            window.location.href = $(e.currentTarget).attr('href') 
        });

        //Interaction video Play
       

         //Track the progress of the video and execute events in specific time
         //Interaction video Play
         $("video:not(.ignore-tracking)").each(function () {
            var video = this;
            $(video)
                .addClass("ignore-tracking")
                .data(
                    "timeline-video",
                    new TimelineVideo([ 25, 50, 75, 100], video)
                ); 
        });

        //Wip location
         //Interaction donwlodad click
         $('.js-satellite--click-download').on('click', e => {
            // e.preventDefault();
            let fileName = this.getFileName( $(e.currentTarget).attr('href') );

            let carousel_download = false
            let carousel_position = 0
            let carousel_total = 0

            if( $('.js-satellite--click-download').hasClass('js-satellite--click-download--carousel') ){
                carousel_download = true;

                let slidePosition = $(e.currentTarget).closest( '.slick-slide' ).attr('data-slick-index')
                carousel_position = parseInt(slidePosition) + 1;

                carousel_total =  $(e.currentTarget).closest( '.slick-slider' ).find('.slick-slide').length
                $('.js-satellite--carousel-wrap').removeClass('js-satellite--carousel-wrap')
            }

            _satellite.track("download_interaction", {
                file_format: ".pdf",
                file_name: fileName,
                file_location: $(e.currentTarget).attr('data-st-download-cat'),
                carousel_download: carousel_download,
                carousel_position: carousel_position,
                carousel_total: carousel_total,
                download_link_clicked: true,
            });
        });

        //Interaction on search item result
        $('body.search-results article a').on('click', e => {
            e.preventDefault();
            let $currentArticle = $(e.currentTarget).closest( 'article' )
            let indexPosition = $('body.search-results article').index( $currentArticle ) +1;
            let titleSearchArticle = $currentArticle.find('h3').find('a').text();
            let searchResult = $('.js-total').val();

            _satellite.track("search_result_actions",  {
                search_result_clicked : "true",
                search_result_position: indexPosition.toString(),
                search_result_title: titleSearchArticle,
                search_result_amount: searchResult,
            });

            window.location.href = $(e.currentTarget).attr('href')
        });
    }

    //HELPER FUNCTIONS
    //Get file name from url
    getFileName( url ){
        return url.substring(url.lastIndexOf('/')+1);
    }
}